import { FC } from 'react';
import styled from 'styled-components';

import InputLabelWrapper, { TextAlign } from './InputLabelWrapper';

const FrozenValue = styled.div`
  height: 60px;
  padding: 2.1rem 0.6rem 0.3333rem 1rem;
  margin-bottom: 15px;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

interface OwnProps {
  error?: string;
  label: string;
  labelKey: string;
  className?: string;
  value?: any;
  textAlign?: TextAlign;
}

const FrozenInput: FC<OwnProps> = props => {
  const hasValue = !!props.value;

  return (
    <InputLabelWrapper
      insideForm
      valid={!props.error}
      hasValue={hasValue}
      error={props.error}
      label={props.label}
      labelKey={props.labelKey}
      textAlign={props.textAlign}
    >
      <FrozenValue>{props.value}</FrozenValue>
    </InputLabelWrapper>
  );
};

export default FrozenInput;
